module.exports = __webpack_public_path__ + "img/HongKongTrust8.5b4823a2.png";